// extracted by mini-css-extract-plugin
export default {"header_inner":"HeaderInner_header_inner__wAvV+"};